<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import {sort} from "../lib/lib";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import VehicleTypeModal from "./VehicleTypeModal.svelte";


    let selectedId = 0;
    let editId = null;
    let loaded = false;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE VEHICLE TYPE'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME', sortable: true, sort_way: 'ASC'},
        {key: 'type', title: 'TYPE', sortable: true,},
        {key: 'description', title: 'DESCRIPTION', sortable: true},
        {key: 'min_pax', title: 'MIN PAX', sortable: true},
        {key: 'max_pax', title: 'MAX PAX', sortable: true},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            $app.vehicle_types = result;
            loaded = true;
        }

        const onFailure = err => {
        };

        R.handle(R.vehicleType.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail: column}) => {
        $app.vehicle_types = sort($app.vehicle_types, column.key, column.sort_way === 'ASC');
    }

    const onCreate = () => {
        editId = 0;
    }

    const onEdit = (item) => {
        selectedId = item.id;
        editId = item.id;
    }

    const closeEdit = () => {
        editId = null;
        load();
    }

    const onDelete = (item) => {
        Alert.delete("Delete vehicle type", `This will permanently delete vehicle type "${item.name}".\nAre you sure?`, () => deleteVehicleType(item.id));
    }

    const deleteVehicleType = (id) => {
        const onSuccess = result => {
            $app.vehicle_types = $app.vehicle_types.filter(x => x.id !== result);
            Notifier.showMessage("Vehicle type deleted");
        }

        const onFailure = err => {
            if (err && err.code === 'object_related') {
                Alert.warning("Delete vehicle type", `Vehicle type is related to ${err.params.vehicles} vehicles!\nYou can not delete this vehicle type.`);
            }
        };

        R.handle(R.vehicleType.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<PageHeader title="Vehicle types" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if loaded}
    <div class="panel">
        <div class="panel-body">
            {#if $app.vehicle_types.length}
                {#if $app.device !== 'xs'}
                    <table class="table table-list table-list-border">
                        <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                        <tbody>
                        {#each $app.vehicle_types as item}
                            <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                                <td class="pointer" on:click="{ () => onEdit(item) }">
                                    <span class:not-active="{ item.is_active < 1 }">{ item.name }</span>
                                </td>
                                <td class="text-gray">
                                    { item.type }
                                </td>
                                <td class="text-gray">
                                    { item.description }
                                </td>
                                <td class="text-gray date-column">
                                    { item.min_pax }
                                </td>
                                <td class="text-gray date-column">
                                    { item.max_pax }
                                </td>
                                <td class="button-column pointer" title="delete vehicle type"
                                    on:click="{ () => onDelete(item) }">
                                    <AppIcon icon="trash" size="16"/>
                                </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                {:else}
                    <div class="table-grid">
                        {#each $app.vehicle_types as item}
                            <div class="grid-row" class:row-selected="{ selectedId === item.id }">
                                <div class="cell-group cell-pad heading-group border-bottom">
                                    <div class="cell">
                                        <span class:not-active="{ item.is_active < 1 }"
                                              on:click="{ () => onEdit(item) }">
                                            { item.name }
                                        </span>
                                    </div>
                                    <div class="cell" on:click="{ () => onDelete(item) }">
                                        <AppIcon icon="trash" size="16"/>
                                    </div>
                                </div>
                                <div class="cell-group cell-pad text-gray">
                                    { item.description }
                                </div>
                                <div class="cell-group text-gray">
                                    <div class="cell cell-pad text-center">
                                        <div class="label">Min Pax</div>
                                        { item.min_pax }
                                    </div>
                                    <div class="cell cell-pad text-center">
                                        <div class="label">Max Pax</div>
                                        { item.max_pax }
                                    </div>
                                </div>
                            </div>
                        {/each}
                    </div>
                {/if}
            {:else}
                <div class="panel-pad d-flex align-items-center">
                    There are no vehicle types.
                    <button class="btn btn-link" on:click="{ onCreate }">
                        add vehicle type
                    </button>
                </div>
            {/if}
        </div>
    </div>
{/if}
{#if editId != null}
    <VehicleTypeModal vehicleTypeId="{ editId }" closeCallback="{ closeEdit }"/>
{/if}
